<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Gestionare Smart Template-uri</h3>
        <div class="section-top-actions">
            <button mat-icon-button class="close-dialog-btn pull-right" (click)="closeDialog()" matTooltip="Închide"
                matTooltipPosition="below">
                <mat-icon>close</mat-icon>
            </button>
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-documente.add')"
                type="button" class="btn btn-sm btn-success pull-right ms-1" (click)="createTemplate()">
                <i class="fa-solid fa-plus"></i>
                Adaugă Smart Template
            </button>
        </div>
    </div>

    <div class="card-container p-2" *ngIf="showCard">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Nume Template</mat-label>
                    <input matInput [(ngModel)]="nameFilter" placeholder="Căutați după nume...">
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Status</mat-label>
                    <mat-select [(ngModel)]="activeValue">
                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Tip Template</mat-label>
                    <mat-select [(ngModel)]="typeValue">
                        <mat-option *ngFor="let type of templateTypes" [value]="type.value">
                            {{ type.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Categorie</mat-label>
                    <mat-select [(ngModel)]="categoryValue">
                        <mat-option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row w-100">
            <div class="col d-flex justify-content-start">
                <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
            </div>
            <div class="col buttons-submit">
                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                    Resetează
                </button>
                <button (click)="applyFilters()" type="submit" class="btn btn-sm btn-primary ms-2">
                    Aplică
                </button>
            </div>
        </div>
    </div>

    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>

    <div class="table-container">
        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
        </table>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>